import { useState, useEffect, useRef } from 'react';
import api from '../../../services/api';

const useAdminEthicsReportApi = (queryParams) => {
  const [fetching, setFetching] = useState(true);
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({ totalRowCount: 0, pageSize: 10, pageIndex: 0 });
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const lastValidQueryParams = useRef(null);

  useEffect(() => {
    const paramsToUse = queryParams && Object.keys(queryParams).length > 0
      ? queryParams
      : lastValidQueryParams.current || { pageNumber: 1, pageSize: 10 };
    lastValidQueryParams.current = paramsToUse;
    setFetching(true);
    api.get(`/v1/ethics-reports/admin?${new URLSearchParams(paramsToUse)}`)
      .then((res) => {
        const result = res.data?.data;
        const items = Array.isArray(result) ? result : (result?.data || []);
        setData(items);
        setPagination({
          totalRowCount: result?.totalRowCount || items.length,
          pageIndex: result?.pageIndex ? result.pageIndex - 1 : 0,
          pageSize: result?.pageSize || items.length || 10,
        });
      })
      .finally(() => setFetching(false));
  }, [queryParams, refreshTrigger]);

  // Süzgeç seçenekleri: kategoriler (kiracının + genel) ve bildirimlere atanmış kişiler.
  const [categories, setCategories] = useState([]);
  const [assignees, setAssignees] = useState([]);
  useEffect(() => {
    api.get('/v1/ethics-report-categories').then((res) => {
      const list = res.data?.data;
      setCategories(Array.isArray(list) ? list : []);
    });
  }, []);
  useEffect(() => {
    api.get('/v1/ethics-reports/admin/assignees').then((res) => {
      const list = res.data?.data;
      setAssignees(Array.isArray(list) ? list : []);
    });
  }, [refreshTrigger]);

  const refresh = () => setRefreshTrigger((p) => p + 1);

  return { fetching, data, pagination, refresh, categories, assignees };
};

export default useAdminEthicsReportApi;
